import { render, staticRenderFns } from "./sh_shpk.vue?vue&type=template&id=40d244dc&scoped=true&"
import script from "./sh_shpk.vue?vue&type=script&lang=js&"
export * from "./sh_shpk.vue?vue&type=script&lang=js&"
import style0 from "./sh_shpk.vue?vue&type=style&index=0&id=40d244dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d244dc",
  null
  
)

export default component.exports